import { useEffect } from 'react';
import { trackChangeTrackingPointEvent, TrackingPoints } from '~/analytics/eventTracker';
import type { Campaign, ProductWithBundleId } from '~/models/CampaignModel';
import { CustomerType } from '~/models/CustomerType';
import { toBasketProduct } from '~/store/basket/basket.helpers';
import { useBasket } from './useBasket';
import { v2Steps } from './v2routes';

interface FunnelTrackerProps {
  campaign: Campaign<ProductWithBundleId>;
  currentStep: number;
}

export const FunnelAnalytics: React.FC<FunnelTrackerProps> = ({ campaign, currentStep }) => {
  useEffect(() => {
    const stepType = v2Steps[currentStep].type;
    const state = useBasket.getState();
    const basketProducts = state.selectedProducts.map((p) => toBasketProduct(p, campaign.customerType as CustomerType));
    switch (stepType) {
      case 'premium': {
        trackChangeTrackingPointEvent({ trackingPoint: TrackingPoints.Content, funnelVersion: 2 });
        break;
      }
      case 'equipment': {
        trackChangeTrackingPointEvent({ trackingPoint: TrackingPoints.Equipment, products: basketProducts, funnelVersion: 2 });
        break;
      }
      case 'internet': {
        trackChangeTrackingPointEvent({ trackingPoint: TrackingPoints.Internet, funnelVersion: 2 });
        break;
      }
      case 'contactInfo': {
        if (!state.selectedVerificationProvider) {
          trackChangeTrackingPointEvent({ trackingPoint: TrackingPoints.Verification, funnelVersion: 2 });
        } else {
          trackChangeTrackingPointEvent({
            trackingPoint: TrackingPoints.ContactInformation,
            verificationProvider: state.selectedVerificationProvider.toLowerCase() as 'bankid' | 'vipps',
            products: basketProducts,
            funnelVersion: 2,
          });
        }
        break;
      }
      case 'summary': {
        trackChangeTrackingPointEvent({ trackingPoint: TrackingPoints.Summary, funnelVersion: 2 });
        break;
      }
      default: {
        // Exhaustive check
        const _tmp: never = stepType;
        console.warn('This step should never happen', _tmp);
        break;
      }
    }
  }, [currentStep, campaign]);

  return null;
};
